/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { useEffect, useState } from 'react';
import {
  SortingState,
  IntegratedSorting,
  DataTypeProvider,
  SearchState,
  IntegratedFiltering,
  EditingState,
  PagingState,
  IntegratedPaging,
} from '@devexpress/dx-react-grid';
import {
  Grid,
  TableHeaderRow,
  Toolbar,
  SearchPanel,
  TableEditColumn,
  DragDropProvider,
  Table,
  TableColumnReordering,
  TableColumnResizing,
  TableColumnVisibility,
  ColumnChooser,
  PagingPanel,
} from '@devexpress/dx-react-grid-material-ui';
import { Command, Loading, PopupEditing } from '../../Shared';
import { getRowId, userroles } from '../../common';
import { createdAtFormatter, sentFormatter } from '../../Shared/colorFormat';

import { AlertLocal, SearchTable } from '../../components';
import { getColumns } from '../../common/columns';

import { Typography } from '@material-ui/core';
import { errorAlert, errorDeleteAlert } from '../../Shared/helpers';
import { useLazyQuery, useMutation } from '@apollo/client';
import { deleteAction, getReminders, updateAction } from '../../graphql';

import { useDepartments, useEmployees, useTemplate } from '../../hooks';
import getRemindersActions from '../../graphql/query/getRemindersActions';
import useResourses from '../../hooks/useResourses';
import { TableComponent } from '../../Shared/TableComponent';
import PopupRAction from '../../pubups/PopupRAction';

export default function Reminders(props: any) {
  const { isRTL, words, start, end, theme } = props;
  const [alrt, setAlrt] = useState({ show: false, msg: '', type: undefined });

  const [arows, setArows] = useState([]);
  const [loading, setLoading] = useState(false);

  const col = getColumns({ isRTL, words });

  const { tempoptions } = useTemplate();
  const [acolumns] = useState(
    [
      col.sent,
      col.time,
      { name: 'title', title: words?.description },
      tempoptions?.resourse && col.resourse,
      tempoptions?.employee && col.employee,
      tempoptions?.department && col.department,
      tempoptions?.contract && col.contract,
    ].filter((x) => x)
  );

  const { employees } = useEmployees();
  const { departments } = useDepartments();
  const { resourses } = useResourses();

  const [tableColumnExtensions]: any = useState([
    { columnName: col.sent.name, width: 120 },
    { columnName: col.time.name, width: 200 },
    { columnName: col.title.name, width: 250 },
    { columnName: col.resourse.name, width: 200 },
    { columnName: col.employee.name, width: 200 },
    { columnName: col.department.name, width: 200 },
    { columnName: col.contract.name, width: 200 },
  ]);
  const [tableColumnVisibilityColumnExtensions] = useState([
    { columnName: 'time', togglingEnabled: false },
  ]);

  const [loadActions, actionsData]: any = useLazyQuery(getRemindersActions, {
    fetchPolicy: 'cache-and-network',
  });

  const refresQuery = {
    refetchQueries: [
      {
        query: getReminders,
        variables: {
          start: start ? start.setHours(0, 0, 0, 0) : undefined,
          end: end ? end.setHours(23, 59, 59, 999) : undefined,
        },
      },
      {
        query: getRemindersActions,
        variables: {
          start: start ? start.setHours(0, 0, 0, 0) : undefined,
          end: end ? end.setHours(23, 59, 59, 999) : undefined,
        },
      },
    ],
  };

  useEffect(() => {
    const variables = {
      start: start ? start.setHours(0, 0, 0, 0) : undefined,
      end: end ? end.setHours(23, 59, 59, 999) : undefined,
    };
    loadActions({
      variables,
    });
  }, [start, end]);

  const [editRAction] = useMutation(updateAction, refresQuery);
  const [removeRAction] = useMutation(deleteAction, refresQuery);

  const commitChangesAction = async ({ deleted }) => {
    if (deleted) {
      const _id = deleted[0];
      const res = await removeRAction({ variables: { _id } });
      if (res?.data?.deleteAction?.ok === false) {
        if (res?.data?.deleteAction?.error.includes('related')) {
          await errorDeleteAlert(setAlrt, isRTL);
        } else {
          await errorAlert(setAlrt, isRTL);
        }
      }
    }
  };

  useEffect(() => {
    if (actionsData?.loading) {
      setLoading(true);
    }
    if (actionsData?.data?.getRemindersActions?.data) {
      const { data } = actionsData.data.getRemindersActions;
      const rdata = data.map((da: any) => {
        let resourseNameAr: any;
        let resourseName: any;
        let departmentNameAr: any;
        let departmentName: any;
        let employeeNameAr: any;
        let employeeName: any;
        if (da?.resourseId) {
          const res = resourses.filter(
            (re: any) => re._id === da.resourseId
          )?.[0];
          resourseNameAr = res?.nameAr;
          resourseName = res?.name;
        }
        if (da?.departmentId) {
          const res = departments.filter(
            (re: any) => re._id === da.departmentId
          )?.[0];
          departmentNameAr = res?.nameAr;
          departmentName = res?.name;
        }
        if (da?.employeeId) {
          const res = employees.filter(
            (re: any) => re._id === da.employeeId
          )?.[0];
          employeeNameAr = res?.nameAr;
          employeeName = res?.name;
        }

        return {
          ...da,
          resourseName,
          resourseNameAr,
          departmentNameAr,
          departmentName,
          employeeNameAr,
          employeeName,
          time: da?.sendtime,
        };
      });
      setArows(rdata);
      setLoading(false);
    }
  }, [actionsData]);

  return (
    <>
      <Grid rows={arows} columns={acolumns} getRowId={getRowId}>
        <SortingState />
        <EditingState onCommitChanges={commitChangesAction} />
        <SearchState />
        <PagingState defaultCurrentPage={0} defaultPageSize={15} />
        <IntegratedSorting />
        <IntegratedFiltering />
        <IntegratedPaging />
        <DragDropProvider />
        <Table
          messages={{
            noData: isRTL ? 'لا يوجد تذكيرات' : 'no data',
          }}
          tableComponent={TableComponent}
          rowComponent={(props: any) => (
            <Table.Row {...props} style={{ height: 40 }}></Table.Row>
          )}
          columnExtensions={tableColumnExtensions}
        />

        <TableColumnReordering
          defaultOrder={[
            col.sent.name,
            col.time.name,
            col.title.name,
            col.resourse.name,
            col.employee.name,
            col.department.name,
            col.contract.name,
          ]}
        />
        <TableColumnResizing defaultColumnWidths={tableColumnExtensions} />

        <TableHeaderRow
          showSortingControls
          titleComponent={({ children }) => {
            return (
              <Typography style={{ fontSize: 14, fontWeight: 'bold' }}>
                {children}
              </Typography>
            );
          }}
        />
        <TableColumnVisibility
          columnExtensions={tableColumnVisibilityColumnExtensions}
          defaultHiddenColumnNames={[col.amount.name]}
        />
        <DataTypeProvider
          for={['time']}
          formatterComponent={createdAtFormatter}
        ></DataTypeProvider>
        <DataTypeProvider
          for={['sent']}
          formatterComponent={(props: any) =>
            sentFormatter({ ...props, editRAction })
          }
        ></DataTypeProvider>
        <TableEditColumn
          showDeleteCommand={userroles?.managereminders?.delete}
          showEditCommand={userroles?.managereminders?.edit}
          commandComponent={Command}
        ></TableEditColumn>

        <Toolbar
          rootComponent={(props: any) => (
            <Toolbar.Root
              style={{
                position: 'absolute',
                left: isRTL ? 40 : undefined,
                right: isRTL ? undefined : 40,
                top: 62,
                zIndex: 115,
              }}
              {...props}
            ></Toolbar.Root>
          )}
        />
        <ColumnChooser />
        <PagingPanel
          pageSizes={
            tempoptions?.pageall ? [5, 10, 15, 20, 50, 0] : [5, 10, 15, 20, 50]
          }
        />

        <SearchPanel
          inputComponent={(props: any) => {
            return <SearchTable isRTL={isRTL} {...props}></SearchTable>;
          }}
        />
        <PopupEditing
          theme={theme}
          addAction={() => null}
          editAction={editRAction}
        >
          <PopupRAction></PopupRAction>
        </PopupEditing>
      </Grid>
      {loading && <Loading isRTL={isRTL} />}
      {alrt.show && (
        <AlertLocal
          isRTL={isRTL}
          type={alrt?.type}
          msg={alrt?.msg}
          top
        ></AlertLocal>
      )}
    </>
  );
}
